import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class DataSourceItem {
    key: string;
    label: string;
    data: OrdinaryObject;
}